import styled from 'styled-components';

export const CloseContainer = styled.div`

`;